// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig } from './client';
import type { ClientOptions } from './ClientOptions.gen';

export const client = createClient(createConfig<ClientOptions>());
